import { TableHeader } from '@/components/ui/table';

export function SuggestedActionHeader() {
  return (
    <TableHeader wide className="text-left align-bottom">
      Suggested Action
    </TableHeader>
  );
}
